/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductPerformanceFilter
 */
export interface ProductPerformanceFilter {
    /**
     * Inclusive start date without a range-length limit.
     * @type {string}
     * @memberof ProductPerformanceFilter
     */
    since?: string;
    /**
     * Inclusive end date without a range-length limit.
     * @type {string}
     * @memberof ProductPerformanceFilter
     */
    until?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductPerformanceFilter
     */
    selectedCentreIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductPerformanceFilter
     */
    selectedDomainIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductPerformanceFilter
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPerformanceFilter
     */
    page?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPerformanceFilter
     */
    search?: string | null;
}

/**
 * Check if a given object implements the ProductPerformanceFilter interface.
 */
export function instanceOfProductPerformanceFilter(value: object): value is ProductPerformanceFilter {
    return true;
}

export function ProductPerformanceFilterFromJSON(json: any): ProductPerformanceFilter {
    return ProductPerformanceFilterFromJSONTyped(json, false);
}

export function ProductPerformanceFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductPerformanceFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'selectedCentreIds': json['selectedCentreIds'] == null ? undefined : json['selectedCentreIds'],
        'selectedDomainIds': json['selectedDomainIds'] == null ? undefined : json['selectedDomainIds'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'page': json['page'] == null ? undefined : json['page'],
        'search': json['search'] === undefined ? undefined : json['search'] === null ? null : json['search'],
    };
}

export function ProductPerformanceFilterToJSON(json: any): ProductPerformanceFilter {
    return ProductPerformanceFilterToJSONTyped(json, false);
}

export function ProductPerformanceFilterToJSONTyped(value?: ProductPerformanceFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'selectedCentreIds': value['selectedCentreIds'],
        'selectedDomainIds': value['selectedDomainIds'],
        'limit': value['limit'],
        'page': value['page'],
        'search': value['search'],
    };
}

